import { Avatar } from '@picsart/design-system/components/Avatar';
import { InlineButton } from '@picsart/design-system/components/InlineButton';
import { IconLogout } from '@picsart/design-system/foundation/icons/IconLogout';
import { IconCoins } from '@picsart/design-system/foundation/icons/IconCoins';
import { IconSettings } from '@picsart/design-system/foundation/icons/IconSettings';
import { IconAccounts } from '@picsart/design-system/foundation/icons/IconAccounts';
import { useTranslator } from '@picsart/rc/services/localization';
import useStyles from './styles';
import type { UserMenuContentProps } from './types';

const UserMenuContent = ({
  isAuthorized,
  username,
  avatarSrc,
  avatarBadge,
  credits,
  onCreditsClick,
  onSettingsClick,
  onLogout,
  onSignIn,
}: UserMenuContentProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  return (
    <>
      {isAuthorized && (
        <div className={classes.userCard}>
          <Avatar size={44} imageSrc={avatarSrc} badge={avatarBadge} />
          <div className={classes.userInfo}>
            <span className={classes.userName}>{username}</span>
            <span className={classes.userHandle}>@{username}</span>
          </div>
        </div>
      )}

      <div className={classes.menuSection}>
        {isAuthorized && credits !== null && (
          <InlineButton
            className={classes.actionButton}
            dataTestId="genai-user-menu-open-credits"
            size="large"
            startIcon={IconCoins}
            alignment="start"
            isFullWidth
            isWithoutBorder
            onClick={onCreditsClick}
          >
            <span className={classes.creditsRow}>
              <span>{translate('Credits')}</span>
              <span className={classes.creditsValue}>
                {credits.toLocaleString()}
              </span>
            </span>
          </InlineButton>
        )}

        {onSettingsClick && (
          <InlineButton
            className={classes.actionButton}
            dataTestId="genai-user-menu-settings"
            size="large"
            startIcon={IconSettings}
            alignment="start"
            isFullWidth
            isWithoutBorder
            onClick={onSettingsClick}
          >
            {translate('Settings')}
          </InlineButton>
        )}

        {isAuthorized ? (
          <InlineButton
            className={classes.actionButton}
            dataTestId="genai-user-menu-logout"
            size="large"
            startIcon={IconLogout}
            alignment="start"
            isFullWidth
            isWithoutBorder
            onClick={onLogout}
          >
            {translate('Log out')}
          </InlineButton>
        ) : (
          <InlineButton
            className={classes.actionButton}
            dataTestId="genai-user-menu-sign-in"
            size="large"
            startIcon={IconAccounts}
            alignment="start"
            isFullWidth
            isWithoutBorder
            onClick={onSignIn}
          >
            {translate('Sign in')}
          </InlineButton>
        )}
      </div>
    </>
  );
};

export default UserMenuContent;
